import {Animated} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const ITEM_GAP = 12;
export const CHEV_SIZE = RFValue(38);

export const CarouselWrapper = styled.View`
  margin: ${RFValue(12)}px 0px;
  margin-top:${RFValue(6)}px;
  justify-content: center;
`;

export const CardsTrack = styled.View<{cardH: number}>`
  height: ${({cardH}) => cardH}px;
`;

export const CardItem = styled(Animated.View)<{cardW: number; cardH: number}>`
  width: ${({cardW}) => cardW}px;
  height: ${({cardH}) => cardH}px;
  margin-right: ${ITEM_GAP}px;
  overflow: hidden;
`;

interface ChevBtnProps {
  side: 'left' | 'right';
  pos: number;
  top: number;
}

export const ChevBtn = styled.TouchableOpacity<ChevBtnProps>`
  position: absolute;
  ${({side, pos}) => (side === 'left' ? `left: ${pos}px;` : `right: ${pos}px;`)}
  top: ${({top}) => top}px;
  width: ${CHEV_SIZE}px;
  height: ${CHEV_SIZE}px;
  border-radius: ${CHEV_SIZE / 2}px;
  background-color: rgba(0, 0, 0, 0.28);
  justify-content: center;
  align-items: center;
`;

export const DotsRow = styled.View`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: ${RFValue(12)}px;
  gap: ${RFValue(5)}px;
`;

export const Dot = styled.View<{active: boolean}>`
  height: ${RFValue(6)}px;
  width: ${({active}) => (active ? RFValue(18) : RFValue(6))}px;
  border-radius: ${RFValue(3)}px;
  background-color: ${({active, theme}) => (active ? theme.colors.carousel_dot_active : theme.colors.carousel_dot_inactive)};
`;

export const DotBtn = styled.TouchableOpacity``;

export const BuyCardWrapper = styled.TouchableOpacity`
  flex: 1;
  border-radius: ${RFValue(20)}px;
  border-width: 1.5px;
  border-color: ${({theme}) => theme.colors.border2};
  background-color: transparent;
  justify-content: center;
  align-items: center;
  gap: ${RFValue(12)}px;
`;

export const BuyCardIconCircle = styled.View`
  width: ${RFValue(52)}px;
  height: ${RFValue(52)}px;
  border-radius: ${RFValue(32)}px;
  background-color: ${({theme}) => theme.colors.primary_light};
  justify-content: center;
  align-items: center;
`;

export const BuyCardLabel = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: ${({theme}) => theme.colors.title};
  letter-spacing: 0.5px;
`;
